<template>
  <div v-if="task">
    <task-body
      :task="task"
      :try-join="tryJoin"
      :try-leave="tryLeave"
      :joined="joinBtnState"
      :join-pending="joinPending"
      :user-left="userLeft"
      :user-rejected="userRejected"
      :rejected-reason="rejectedReason"
      :participant="participant"
    />
    <box>
      <h2 class="mb-2">{{ $t('pleaseNote') }}</h2>
      <ol class="text-warning small pl-3 pt-0 mb-0">
        <li>{{ $t('yourAccountPersonalChannel') }}</li>
        <li>{{ $t('yourChannelSubPublic') }}</li>
      </ol>
    </box>
    <box>
      <h3 class="mb-5">{{ $tc('reward', 2) }}</h3>
      <div class="mb-1">
        <masonry :cols="{ default: 3, 1200: 2, 992: 1 }" :gutter="20">
          <reward-custom
            v-if="task.rewardFollow"
            class="mb-4"
            :title="$filters.capitalize($tc('follow', 1))"
            disabled-limits
            header-class="youtube-color"
            :icon="getIcon(task.type, 'follow')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardFollow"
          />
          <reward-custom
            v-if="task.rewardVideo"
            class="mb-4"
            :title="$filters.capitalize($tc('video', 1))"
            disabled-limits
            header-class="youtube-color"
            :icon="getIcon(task.type, 'video')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardVideo"
          >
            <div
              v-if="rewardRules.rewardVideo.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardVideo" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward-custom>
          <reward-custom
            v-if="task.rewardComment"
            class="mb-4"
            :title="$filters.capitalize($tc('comment', 1))"
            header-class="youtube-color"
            :icon="getIcon(task.type, 'comment')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardComment"
          >
            <div
              v-if="rewardRules.rewardComment.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardComment" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward-custom>
          <reward-custom
            v-if="task.rewardLike"
            class="mb-4"
            :title="$filters.capitalize($tc('like', 1))"
            header-class="youtube-color"
            :icon="getIcon(task.type, 'like')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardLike"
          >
            <div
              v-if="rewardRules.rewardLike.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardLike" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward-custom>
        </masonry>
      </div>
    </box>
    <b-modal
      ref="beforeJoinModal"
      centered
      size="lg"
      title="Describe your offer"
      title-tag="h2"
      ok-title="Send request"
      @ok="join"
    >
      <b-form>
        <b-form-group label="Link to youtube chanel:">
          <b-form-input type="text" size="lg" required />
        </b-form-group>
        <b-form-group label="Subscribers:">
          <b-form-input type="text" size="lg" required />
        </b-form-group>
        <b-form-group label="Message:">
          <b-form-textarea style="min-height: 150px" />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';
import RewardCustom from '@/components/RewardCustom.vue';

export default {
  mixins: [taskMixin],

  components: { RewardCustom },

  computed: {
    rewardRules() {
      return {
        rewardComment: [
          {
            name: this.$t('minCharWithTags'),
            value:
              this.task.rewardComment &&
              this.task.rewardComment.params.minLength
          },
          {
            name: this.$t('maxPostAgeDays'),
            value:
              this.task.rewardComment &&
              this.task.rewardComment.params.maxPostAge
                ? `${this.task.rewardComment.params.maxPostAge} days`
                : null
          }
        ].filter(el => el.value),
        rewardLike: [
          {
            name: this.$t('maxPostAgeDays'),
            value:
              this.task.rewardLike && this.task.rewardLike.params.maxPostAge
                ? `${this.task.rewardLike.params.maxPostAge} days`
                : null
          }
        ].filter(el => el.value),
        rewardVideo: [
          {
            name: this.$t('hashTagsMustAdd'),
            value:
              this.task.rewardVideo && this.task.rewardVideo.params.tags
                ? ['', ...this.task.rewardVideo.params.tags].join(' #')
                : null
          },
          {
            name: this.$t('descriptionLink'),
            value:
              this.task.rewardVideo &&
              this.task.rewardVideo.params.descriptionLink
                ? this.task.rewardVideo.params.descriptionLink
                : null
          }
        ].filter(el => el.value)
      };
    }
  },

  methods: {
    tryJoin() {
      const socialNetworks = this.$store.state.app.user.socialNetworks || {};

      if (!socialNetworks.youtube) {
        this.$notify('alert', {
          text: this.$t('connectNetworks.connectYoutubeAtFirst'),
          variant: 'danger',
          time: 0
        });
        return;
      }
      this.join();
    }
  }
};
</script>
